module.exports = __webpack_public_path__ + "img/hakuna_xmas_catch.aafd456c.jpg";